import { render } from "./NodeRoleOptions.vue?vue&type=template&id=c42ff636"
import script from "./NodeRoleOptions.vue?vue&type=script&lang=js"
export * from "./NodeRoleOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__